// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__2dnfR","header":"style_header__ej96g"};